import { Button, FormControl, InputLabel, Select, MenuItem, Grid } from "@material-ui/core"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { FormatoFechaIso } from "./../../../../../utils/FormatFecha"
import { addFechaSalidaAction, obtenerFechaSalidaAction, addItemsAction, resetPenalizacionAction} from "../../../../../ducks/cambioPaqueteDuck"
import { formatDinero } from "../../../../../utils/formatDinero"

const FieldSalida = () => {
    // const { cliente } = useSelector(store => store.cambios)
    const { listaFechaSalida, fechaSalida, paquete, listaItems, cantidadPasajeros, clavePaquete } = useSelector(store => store.cambiosPaquete)
    const [editar, setEditar] = useState(false)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerFechaSalidaAction({ ClavePaquete: clavePaquete }))
    }, [dispatch, clavePaquete])

    const handleGuardar = () => {
        const fecha = fechaSalida.split(",")[2]
        const salida = listaFechaSalida.find(salida => salida.FechaSalida === fecha)
        let arraItems = listaItems.filter(item => item.type !== 'SALIDA')
        let itemPaquete = {
            id: salida.IdObjeto,
            name: `${salida.Descripcion} - ${FormatoFechaIso({date: salida.FechaSalida, formato: "yyyy/MM/dd"})}`,
            price: salida.Precio,
            currency: paquete.Moneda?.Clave,
            type: "SALIDA",
            quantity: cantidadPasajeros
        }
        arraItems.push(itemPaquete)
        dispatch(addItemsAction({listaItem: arraItems}))
        dispatch(resetPenalizacionAction())
        setEditar(false)
    }

    const handleSelecFecha = (event) => {
        const fecha =  event.target.value.split(",")[2]
        dispatch(addFechaSalidaAction({ fechaSalida: event.target.value, fecha }))

    }
    const hangdleClickEditar = () => {
        setEditar(!editar)
    }
    return (
        <div>
            <Grid container>
                <Grid item xs={12}>
                    <div style={{ margin: "0.5rem 0", display: "flex", justifyContent: "center", alignItems: "center" }}>
                        <FormControl variant="outlined" style={{ width: "100%" }}>
                            <InputLabel id="lFecha">Fecha de salida</InputLabel>
                            <Select
                                disabled={!editar}
                                labelId="lFecha"
                                id="SFecha"
                                name="SFecha"
                                onChange={handleSelecFecha}
                                label="Fecha de salida"
                                value={fechaSalida}
                            >
                                <MenuItem value="0,0,0" disabled>
                                    {"Seleccione una opción"}
                                </MenuItem>
                                {listaFechaSalida.map((item, index) => (
                                    <MenuItem key={index} value={`${item.IdObjeto},${item.IdBloqueSalida},${item.FechaSalida}`}>
                                        {`${FormatoFechaIso({ date: item.FechaSalida, formato: "dd MMMM yyyy" })} - ${item.Descripcion} - ${formatDinero(item.Precio)}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        {
                            (!editar) &&
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="primary"
                                onClick={hangdleClickEditar}
                                disabled={clavePaquete === "0"}
                            >
                                Editar
                            </Button>
                        }
                        {
                            (editar) &&
                            <div style={{ margin: "0 2%", display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="primary"
                                    disabled={fechaSalida === "0,0,0"}
                                    onClick={handleGuardar}
                                >
                                    Guardar
                                </Button>
                                <Button
                                    style={{ margin: "0 2%" }}
                                    variant="contained"
                                    color="default"
                                    onClick={hangdleClickEditar}
                                >
                                    Cancelar
                                </Button>
                            </div>
                        }
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
export default FieldSalida